import React from 'react';
import { Link } from 'react-router-dom';

const DashboardGuide = _ => {
  return (
    <div className='col-12 p-4 mx-auto'>
      <div className='d-flex justify-content-center'>
        <video width='fit-content' height='500' controls>
          <source
            src={`${ASSET_ENDPOINT}videos/learn_panel.mp4`}
            type='video/mp4'
          />
        </video>
      </div>
      <div className='col-12 d-flex justify-content-between align-items-center'>
        <h3 className='text-right text-muted py-4'>
          <div className='text-right'>
            {locales('titles.CafeAdminDashbaordGuide')}
          </div>
        </h3>
      </div>
      <section className='my-3'>
        <div className='panel-heading'>
          <i className='fas fa-list-alt px-1' />
          {locales('titles.cafesCalculations')}
        </div>
        <div className='panel-body'>
          <div className='d-flex border-bottom p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' />{' '}
              {locales('titles.cafeImpurityAmount')} :
            </div>
            <div className='text-muted'>
              {locales('titles.cafeImpurityAmountDescription')}
            </div>
          </div>

          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' />{' '}
              {locales('titles.averageOrderAmountPerReservation')} :
            </div>
            <div className='text-muted'>
              {locales('titles.averageOrderAmountPerReservationDescription')}
            </div>
          </div>

          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' />{' '}
              {locales('titles.averageTotalPeoplePerReservationDescription')} :
            </div>
            <div className='text-muted'>
              {locales('titles.averageTotalPeoplePerReservationDescription')}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DashboardGuide;
